import API from "./api";
import * as MESSAGE from "../const/message";
import { BaitaiShubetsuSearchParam, BaitaiShubetsuDataSet } from "../types/WebData";
import { HTTP_STATUS_CODE } from "../const/index";

/**
 * baitai_shubetsuテーブルAPI get
 *
 * @param {number} baitaishubetsuId
 */
export const getSearchBaitaiShubetsuId = async (baitaishubetsuId: number) => {
  const result = await API.get(`/cms-api/baitaishubetsu/id`, { params: { id: baitaishubetsuId } })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    })
  return result;
};

/**
 * baitai_shubetsuテーブルAPI
 * 媒体種別情報検索
 *
 * @param {BaitaiShubetsuSearchParam} searchParam
 * @return {*} 
 */
export const postSearchBaitaiShubetsu = async (searchParam: BaitaiShubetsuSearchParam) => {
  const result = await API.post(`/cms-api/baitaishubetsu/search`, searchParam)
    .then((res) => {
      return { data: res.data.data, isError: false, message: "" };
    })
    .catch((error) => {
      return { data: [], isError: true, message: MESSAGE.SYSTEM_ERROR };
    });
  return result;
};

/**
 * baitai_shubetsuテーブルAPI 更新
 *
 * @param {BaitaiShubetsuDataSet} postData
 */
export const updateBaitaiShubetsu = async (postData: BaitaiShubetsuDataSet) => {
  if (postData.id === 0) {
    // insert
    const result = await API.post("/cms-api/baitaishubetsu", postData)
      .then((res) => {
        return { isError: false, message: MESSAGE.TOROKU_SEIKO };
      })
      .catch((error) => {
        return { isError: true, message: MESSAGE.SYSTEM_ERROR };
      });
    return result;
  } else {
    // update
    const result = await API.put("/cms-api/baitaishubetsu/id", postData)
      .then((res) => {
        return { isError: false, message: MESSAGE.KOSHIN_SEIKO };
      })
      .catch((error) => {
        const status = error.response.status;
        const message = status === HTTP_STATUS_CODE.CONFLICT_ERROR ? MESSAGE.CONFLICT_ERROR : MESSAGE.SYSTEM_ERROR;
        return { isError: true, message: message, data: [] };
      });
    return result;
  }
};

/**
 * baitai_shubetsuテーブルAPI del_flg更新
 *
 * @param {number} id
 * @param {boolean} del_flg
 */
export const deleteBaitaiShubetsu = async (id: number, del_flg: boolean) => {
  const result = await API.put("/cms-api/baitaishubetsu/delete", { id: id, del_flg: del_flg })
    .then((res) => {
      return { isError: false, message: "" };
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });
  return result;
};